import type { Meta, StoryFn } from '@storybook/react';

import { URLDisplay } from '@pega/cosmos-react-core';
import type { URLDisplayProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/URL',
  component: URLDisplay
} as Meta;

export const URLDisplayDemo: StoryFn<URLDisplayProps> = (args: URLDisplayProps) => (
  <URLDisplay value={args.value} displayText={args.displayText} variant={args.variant} />
);

URLDisplayDemo.args = {
  value: 'https://www.google.com/',
  displayText: 'Example URL',
  variant: 'link'
};

URLDisplayDemo.argTypes = {
  value: { control: { type: 'text' } },
  displayText: { control: { type: 'text' } },
  variant: { options: ['link', 'text', 'qrcode'], control: { type: 'select' } }
};
